document.addEventListener("DOMContentLoaded", function () {
  var catalogMenus = document.querySelectorAll("[data-pb-catalog]");

  catalogMenus.forEach(function (menu) {
    var trigger = menu.querySelector("[data-pb-catalog-trigger]");
    var overlay = menu.querySelector("[data-pb-catalog-overlay]");
    var drawer = menu.querySelector("[data-pb-catalog-drawer]");
    var closeBtn = menu.querySelector("[data-pb-catalog-close]");
    var views = menu.querySelectorAll("[data-pb-view]");
    var openButtons = menu.querySelectorAll("[data-pb-open-submenu]");
    var backButtons = menu.querySelectorAll("[data-pb-back]");
    var lastFocusedElement = null;
    var history = ["root"];

    if (!trigger || !overlay || !drawer) {
      return;
    }

    function showView(viewName) {
      views.forEach(function (view) {
        var isActive = view.getAttribute("data-pb-view") === viewName;
        view.classList.toggle("is-active", isActive);
      });
    }

    function resetViews() {
      history = ["root"];
      showView("root");
    }

    function openMenu() {
      lastFocusedElement = document.activeElement;
      menu.classList.add("is-open");
      overlay.hidden = false;
      drawer.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
      document.body.classList.add("pb-catalog-menu-open");
    }

    function closeMenu() {
      menu.classList.remove("is-open");
      overlay.hidden = true;
      drawer.setAttribute("aria-hidden", "true");
      trigger.setAttribute("aria-expanded", "false");
      document.body.classList.remove("pb-catalog-menu-open");
      resetViews();

      if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
        lastFocusedElement.focus();
      }
    }

    trigger.addEventListener("click", function () {
      if (menu.classList.contains("is-open")) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closeMenu);
    }

    overlay.addEventListener("click", closeMenu);

    openButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var target = button.getAttribute("data-pb-open-submenu");
        if (!target) {
          return;
        }

        history.push(target);
        showView(target);
      });
    });

    backButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (history.length > 1) {
          history.pop();
        }

        var previousView = history[history.length - 1] || "root";
        showView(previousView);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (!menu.classList.contains("is-open")) {
        return;
      }

      if (event.key === "Escape") {
        closeMenu();
      }
    });

    // ===================================================================
    // CAROUSEL "PRODUITS STARS" — flèches de navigation
    // Chaque bloc .pb-catalog-menu__stars peut contenir jusqu'à 6 cartes,
    // avec 2 visibles à la fois. Les flèches font défiler d'une carte à
    // la fois et se désactivent en début/fin de liste.
    // ===================================================================

    var starsGrids = menu.querySelectorAll("[data-pb-stars-grid]");

    starsGrids.forEach(function (grid) {
      var wrapper = grid.closest(".pb-catalog-menu__stars");
      if (!wrapper) {
        return;
      }

      var prevBtn = wrapper.querySelector("[data-pb-stars-prev]");
      var nextBtn = wrapper.querySelector("[data-pb-stars-next]");

      if (!prevBtn || !nextBtn) {
        return;
      }

      function updateNavState() {
        var maxScroll = grid.scrollWidth - grid.clientWidth - 1;
        var atEnd = grid.scrollLeft >= maxScroll;
        prevBtn.disabled = grid.scrollLeft <= 0;
        nextBtn.disabled = atEnd;
        wrapper.classList.toggle("is-at-end", atEnd);
      }

      function scrollByCard(direction) {
        var card = grid.querySelector(".pb-catalog-menu__star-card");
        if (!card) {
          return;
        }

        var cardWidth = card.getBoundingClientRect().width;
        var gap = 10;
        grid.scrollBy({ left: direction * (cardWidth + gap), behavior: "smooth" });
      }

      prevBtn.addEventListener("click", function () {
        scrollByCard(-1);
      });

      nextBtn.addEventListener("click", function () {
        scrollByCard(1);
      });

      grid.addEventListener("scroll", updateNavState, { passive: true });
      window.addEventListener("resize", updateNavState);

      updateNavState();
    });
  });
});